import { makeAutoObservable } from 'mobx';
// Request
import { TinTucRequest } from '../requests/TinTucRequest'


class TinTucStore {
    constructor() {
        makeAutoObservable(this);
    }
    newsList = []
    newDetails = {}
    tinTucTotalCount = 0

    tintucQueryParams = {
        page: 0,
        size: 10,
    }

    setTintucQueryParams = payload => {
        this.tintucQueryParams = payload
    }

    /** Get work schedule */
    getAllNews = () => {
        return new Promise((resolve, reject) => {
            TinTucRequest.getAllNews(
                this.tintucQueryParams.page,
                this.tintucQueryParams.size
            )
                .then(response => {
                    this.newsList = [...this.newsList, ...response.data.data]
                    this.tinTucTotalCount = response.data.total_count
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

    getById = id => {
        return new Promise((resolve, reject) => {
            TinTucRequest.getById(id)
                .then(response => {
                    // console.log(response.data)
                    this.newDetails = response.data
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

    create = tinTuc => {
        return new Promise((resolve, reject) => {
            TinTucRequest.create(tinTuc)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

    update = tinTuc => {
        return new Promise((resolve, reject) => {
            TinTucRequest.update(tinTuc)
                .then(response => {
                    console.log(response.data.data)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

    delete = id => {
        return new Promise((resolve, reject) => {
            TinTucRequest.delete(id)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

    clear = () => {
        this.newsList.length = 0
        this.tinTucTotalCount = 0
        this.tintucQueryParams = {
            page: 0,
            size: 10,
        }
    }
    clearNewsList = () => {
        this.newsList = []
    }
    clearNewDetails = () => {
        this.newDetails = {}
    }
}

export default new TinTucStore()
